import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { Link } from '@shared/componentsStyled/Link'
import styled from 'styled-components'

export function SectionProtected() {
	return (
		<Section>
			<ViewRoot>
				<TextTitle>Как гарантируется надёжность?</TextTitle>
				<ViewRow>
					<ViewItem>
						<ImageStyled name='how-to-1.png' alt='' />
						<Text>
							Работа исключительно с залоговым кредитованием, где по текущей статистике{' '}
							<strong>каждый рубль инвестора защищён двумя рублями стоимости недвижимости</strong>.
						</Text>
					</ViewItem>
					<ViewItem>
						<ImageSquaredStyled name='how-to-2.png' alt='' />
						<Text>
							Наличие обязательного по закону собственного резервного фонда и компенсационного фонда
							СРО
						</Text>
					</ViewItem>
					<ViewItem last>
						<ImageStyled name='investProtected3.png' alt='' />
						<Text>
							Работа под прямым надзором{' '}
							<Link
								href='https://www.cbr.ru/finorg/foinfo/?ogrn=1196658040677'
								target='_blank'
								rel='noopener noreferrer nofollow'
							>
								ЦБ РФ
							</Link>{' '}
							и{' '}
							<Link href='https://nokkunion.ru/' target='_blank' rel='noopener noreferrer nofollow'>
								Ассоциации СРО НОКК
							</Link>
							. Наличие нормативов по дополнительному резервированию средств на просроченные займы.
						</Text>
					</ViewItem>
				</ViewRow>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	marginBottom: 60,
	paddingLeft: 20,
	paddingRight: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 100,
		paddingLeft: 60,
		paddingRight: 60,
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const ViewRow = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'flex-start',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
}))

interface ViewItemProps {
	last?: boolean
}

const ViewItem = styled.div<ViewItemProps>(({ theme, last = false }) => ({
	flex: 1,
	maxWidth: 264,
	marginRight: 0,
	marginBottom: last ? 0 : 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginRight: last ? 0 : 30,
		marginBottom: 0,
		justifyContent: 'space-between',
	},
}))

const ImageStyled = styled(Image)(({ theme }) => ({
	width: 264,
	marginBottom: 30,
	aspectRatio: '240/180',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 20,
	},
}))

const ImageSquaredStyled = styled(Image)(({ theme }) => ({
	width: 200,
	marginBottom: 30,
	aspectRatio: '200/200',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 20,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))
